import * as React from 'react'
import * as css from './IconListDetailed.module.css'
import HTag from 'components/common/HTag'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import CTALink from 'components/common/CTALink'
import BlueprintGraphic from 'components/BlueprintGraphic'

const IconListDetailed = ({ heading, details }) => (
	<section className="ctnr padding relative">
		<header className="ctnr-half ml-0">
			<HTag className="h0" {...heading} />
		</header>

		<ul className={css.list}>
			{details?.map((item, key) => (
				<li className="richtext sm max-w-[270px]" key={key}>
					{!!item.icon && (
						<GatsbyImage image={getImage(item.icon.asset)} alt="" />
					)}
					<h3 className="h3">{item.title}</h3>
					<p>{item.description}</p>
					<CTALink {...item.link} />
				</li>
			))}
		</ul>

		<BlueprintGraphic style={{ bottom: 0, right: 0 }} />
	</section>
)

export default IconListDetailed
